/* eslint-disable*/
import {
  makeStyles,
  RACButton,
  RACCheckBox,
  RACCOLOR,
  RACTable,
  RACTableCell,
  RACTableRow,
  Typography,
  RACDateTimeLabel
} from "@rentacenter/racstrap";
import i18n from "i18next"; // Import i18next
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation } from "react-router-dom";
import {
  ApiStateWrapper,
  Loader,
} from "../../../common/ApiStateWrapper/ApiStateWrapper";
import { useMultiSelectHandlers } from "../../../common/multiSelect";
import { days, RECEIPT_TYPE } from "../../../constants/constants";
import {
  usePaymentHistory,
  usePaymentHistoryActions,
} from "../../../context/PaymentHistory/PaymentHistoryProvider";
import { useStoreDetails } from "../../../context/Store/StoreProvider";
import { LimitedSet } from "../../../domain/LimitedSet";
import { CustomerLocationState } from "../../../types/types";
import {
  formatDateString,
  formatStringDateHoursAndMinutes,
} from "../../../utils/utils";
import { Document } from "../../Document/Document";

const useClasses = makeStyles((theme: any) => ({
  tableContentColor: {
    color: RACCOLOR.INDEPENDENCE,
  },
  tableRoot: {
    marginTop: theme.typography.pxToRem(16),
  },
  tableBody: {
    position: "relative",
  },
  tableHead: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "white",
  },
  contentHeight: {
    height: theme.typography.pxToRem(400),
  },
}));

interface CurrentPaymentHistoryProps {
  selectedReceipts: LimitedSet<string | number | undefined>;
  setSelectedReceipts: (
    receipts: LimitedSet<string | number | undefined>
  ) => void;
  disableEmailReceipts: boolean;
}

export const CurrentPaymentHistory = ({
  selectedReceipts,
  setSelectedReceipts,
  disableEmailReceipts,
}: CurrentPaymentHistoryProps) => {
  const [receiptId, setReceiptId] = useState("");
  const [receiptTitle, setReceiptTitle] = useState("");
  const { t } = useTranslation();
  const {
    payments,
    total,
    numberOfLoadedPayments,
    hasApiError,
    loading,
    init,
  } = usePaymentHistory();

  const { maxReceiptsEmailable, MXAccountMgmtAccess, DateTimeLocalization, store } = useStoreDetails();

  const [handleCheckReceipt, handleCheckAllReceipts] = useMultiSelectHandlers(
    payments?.map(({ receiptId }) => receiptId) ?? [],
    selectedReceipts,
    setSelectedReceipts
  );

  const renderTableHead = () => (
    <>
      {maxReceiptsEmailable > 0 && (
        <RACTableCell>
          <RACCheckBox
            checked={
              selectedReceipts.full ||
              selectedReceipts.size === payments?.length
            }
            onChange={(event) => handleCheckAllReceipts(event.target.checked)}
            disabled={disableEmailReceipts}
          />
        </RACTableCell>
      )}
      <RACTableCell>
        <Typography variant="h5">{t("Date paid")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Day")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Time")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Receipt #")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Total Payment")}</Typography>
      </RACTableCell>
      <RACTableCell align="center">
        <Typography variant="h5">{t("Next Due Date")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Days Ext")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("# Days late")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Store")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Payment Origin")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Tender Type")}</Typography>
      </RACTableCell>
      <RACTableCell>
        <Typography variant="h5">{t("Net Rent")}</Typography>
      </RACTableCell>
      <RACTableCell>
        {MXAccountMgmtAccess != 1 ? (
          <Typography variant="h5">{t("Club")}</Typography>
        ) : (
          <Typography variant="h5">{t("Invoice #")}</Typography>
        )}
      </RACTableCell>
    </>
  );

  const renderTableContent = () => (
    <>
      {payments?.map((dataObj, index) => {
        const paymentDate = new Date(dataObj.paymentDate || "");
        const paymentMethodTypes = dataObj.paymentMethodType || [];
        
       const translatedPaymentMethods = (() => {
  const uniqueTranslations = new Map();
  for (const method of paymentMethodTypes) {
    const translated = i18n.t(method);
    if (!uniqueTranslations.has(translated)) {
      uniqueTranslations.set(translated, true);
    }
  }
  return Array.from(uniqueTranslations.keys()).join(", ");
})();

        return (
          <RACTableRow key={index} hover backgroundColor="white">
            {maxReceiptsEmailable > 0 && (
              <RACTableCell>
                <RACCheckBox
                  checked={selectedReceipts.has(dataObj.receiptId)}
                  disabled={
                    (selectedReceipts.full &&
                      !selectedReceipts.has(dataObj.receiptId)) ||
                    disableEmailReceipts
                  }
                  onChange={(event) =>
                    handleCheckReceipt(event.target.checked, dataObj.receiptId)
                  }
                />
              </RACTableCell>
            )}
            <RACTableCell>
              {DateTimeLocalization ?
                  <RACDateTimeLabel 
                  value={dataObj.paymentDate || ''} 
                  country={store?.countryAbb} 
                  displayType={'ShortDate'}
                  className={classes.tableContentColor}
                  />
                  :
              <Typography variant="body2" className={classes.tableContentColor}>
                {formatDateString(dataObj.paymentDate)}
              </Typography>
              }
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {days[paymentDate.getDay()]}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {formatStringDateHoursAndMinutes(dataObj.paymentDate)}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <RACButton
                variant="text"
                size="small"
                color="primary"
                onClick={() => {
                  // eslint-disable-next-line no-console
                  console.log("Implement mee");
                }}
              >
                <Typography
                  variant="body2"
                  color="primary"
                  onClick={() => {
                    setReceiptId(dataObj.receiptId as string);
                  }}
                >
                  {dataObj.receiptId}
                </Typography>
              </RACButton>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.paymentAmount !== "null"
                  ? `$${dataObj.paymentAmount}`
                  : "-"}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              {DateTimeLocalization ?
                  <RACDateTimeLabel 
                  value={dataObj.nextDueDate || ''} 
                  country={store?.countryAbb} 
                  displayType={'ShortDate'}
                  className={classes.tableContentColor}
                  />
                  :
              <Typography
                align="center"
                variant="body2"
                className={classes.tableContentColor}
              >
                {formatDateString(dataObj.nextDueDate)}
              </Typography>
              }
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.daysExtension}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.daysLate}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.storeNumber}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {i18n.t(dataObj?.paymentOrigin?.description || "")}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {translatedPaymentMethods}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              <Typography variant="body2" className={classes.tableContentColor}>
                {dataObj.netRentalRevenue !== "null"
                  ? `$${dataObj.netRentalRevenue}`
                  : "-"}
              </Typography>
            </RACTableCell>
            <RACTableCell>
              {MXAccountMgmtAccess != 1 ? (
                <Typography
                  variant="body2"
                  className={classes.tableContentColor}
                >
                  {dataObj.clubPayment !== "null"
                    ? `$${dataObj.clubPayment}`
                    : "-"}
                </Typography>
              ) : (
                "-"
              )}
            </RACTableCell>
          </RACTableRow>
        );
      })}
    </>
  );
  const classes = useClasses();
  const { fetchPaymentHistory, resetPaymentData } = usePaymentHistoryActions();

  const initialLoad = () => {
    fetchPaymentHistory(true);
    return resetPaymentData;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(initialLoad, []);

  const location = useLocation<CustomerLocationState>();
  useEffect(() => {
    if (!location?.state?.customer) return;
    initialLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.customer]);

  return (
    <>
      {receiptId && (
        <Document
          title={receiptTitle}
          documentId={receiptId}
          typeId={RECEIPT_TYPE}
          onClose={() => setReceiptId("")}
          changeTitle={setReceiptTitle}
        />
      )}
      <InfiniteScroll
        next={fetchPaymentHistory}
        dataLength={numberOfLoadedPayments}
        hasMore={numberOfLoadedPayments < total}
        height={330}
        loader={<Loader />}
      >
        <ApiStateWrapper
          loading={loading && init}
          hasApiError={hasApiError}
          response={payments}
          successContent={
            <RACTable
              bodyClasses={{ root: classes.tableBody }}
              headClasses={{ root: classes.tableHead }}
              classes={{ root: classes.tableRoot }}
              renderTableHead={renderTableHead}
              renderTableContent={renderTableContent}
            />
          }
          classes={{
            loader: classes.contentHeight,
            apiError: classes.contentHeight,
            noItems: classes.contentHeight,
          }}
        />
      </InfiniteScroll>
    </>
  );
};
